/* eslint-disable */

import React from 'react';
import styled from 'styled-components'; // package to define css class
//import React, {useState, useEffect} from 'react';
//import {BrowserRouter as Router, Switch, Route, Link, useParams} from 'react-router-dom';
//import {storage, db} from '../firebase';

function TermsOfService() {
  return (
    <div style={{ marginTop: 50, marginBottom: 50 }}>
      <h1 style={{ textAlign: 'center', marginBottom: 20 }}>End-User Licence Agreement (EULA) of Vivablee</h1>
      <DivResponsive>
        This End-User Licence Agreement ("EULA") is a legal agreement between you and Vivablee Limited.
      </DivResponsive>
      <DivResponsive>
        This EULA agreement governs your acquisition and use of our Vivablee software ("Software") directly from Vivablee Limited or indirectly through a Vivablee Limited authorised reseller or distributor (a "Reseller").
      </DivResponsive>

      <DivResponsive>
        Please read this EULA agreement carefully before completing the installation process and using the Vivablee software. It provides a licence to use the Vivablee software and contains warranty information and liability disclaimers.
      </DivResponsive>

      <DivResponsive>
        If you register for a free trial of the Vivablee software, this EULA agreement will also govern that trial. By clicking "accept" or installing and/or using the Vivablee software, you are confirming your acceptance of the Software and agreeing to become bound by the terms of this EULA agreement.
        If you are entering into this EULA agreement on behalf of a company or other legal entity, you represent that you have the authority to bind such entity and its affiliates to these terms and conditions. If you do not have such authority or if you do not agree with the terms and conditions of this EULA agreement, do not install or use the Software, and you must not accept this EULA agreement.

      </DivResponsive>

      <DivResponsive>
        This EULA agreement shall apply only to the Software supplied by Vivablee Limited herewith regardless of whether other software is referred to or described herein. The terms also apply to any Vivablee Limited updates, supplements, Internet-based services, and support services for the Software, unless other terms accompany those items on delivery. If so, those terms apply.

      </DivResponsive>

      <H4Responsive>Licence Grant</H4Responsive>


      <DivResponsive>Vivablee Limited hereby grants you a personal, non-transferable, non-exclusive licence to use the Vivablee software on your devices in accordance with the terms of this EULA agreement.
      </DivResponsive>
      <DivResponsive>You are permitted to load the Vivablee software (for example a PC, laptop, mobile or tablet) under your control. You are responsible for ensuring your device meets the minimum requirements of the Vivablee software.
      </DivResponsive>
      <DivResponsive>You are not permitted to:
      </DivResponsive>

      <ULResponsive>
        <li>Edit, alter, modify, adapt, translate or otherwise change the whole or any part of the Software nor permit the whole or any part of the Software to be combined with or become incorporated in any other software, nor decompile, disassemble or reverse engineer the Software or attempt to do any such things
        </li>
        <li>Reproduce, copy, distribute, resell or otherwise use the Software for any commercial purpose
        </li>
        <li>Allow any third party to use the Software on behalf of or for the benefit of any third party
        </li>
        <li>Use the Software in any way which breaches any applicable local, national or international law
        </li>
        <li>use the Software for any purpose that Vivablee Limited considers is a breach of this EULA agreement</li>
      </ULResponsive>


      <H4Responsive>Intellectual Property and Ownership</H4Responsive>

      <DivResponsive>Vivablee Limited shall at all times retain ownership of the Software as originally downloaded by you and all subsequent downloads of the Software by you. The Software (and the copyright, and other intellectual property rights of whatever nature in the Software, including any modifications made thereto) are and shall remain the property of Vivablee Limited.
      </DivResponsive>
      <DivResponsive>Vivablee Limited reserves the right to grant licences to use the Software to third parties.
      </DivResponsive>

      <H4Responsive>Termination</H4Responsive>
      <DivResponsive>This EULA agreement is effective from the date you first use the Software and shall continue until terminated. You may terminate it at any time upon written notice to Vivablee Limited.
      </DivResponsive>

      <DivResponsive>It will also terminate immediately if you fail to comply with any term of this EULA agreement. Upon such termination, the licences granted by this EULA agreement will immediately terminate and you agree to stop all access and use of the Software. The provisions that by their nature continue and survive will survive any termination of this EULA agreement.
      </DivResponsive>


      <H4Responsive>Governing Law</H4Responsive>
      <DivResponsive>This EULA agreement, and any dispute arising out of or in connection with this EULA agreement, shall be governed by and construed in accordance with the laws of Hong Kong.
      </DivResponsive>

    </div>
  );
}

const DivResponsive = styled.p`
  margin-left: 100px;
  margin-right: 100px;
  margin-top: 10px;
  @media only screen and (max-width: 768px) {
    margin-left: 20px;
    margin-right: 20px;
  }
`;

const H4Responsive = styled.h4`
  margin-left: 100px;
  margin-right: 100px;
  margin-top: 10px;
  @media only screen and (max-width: 768px) {
    margin-left: 20px;
    margin-right: 20px;
  }
`;

const ULResponsive = styled.ul`
  margin-left: 140px;
  margin-right: 100px;
  margin-top: 10px;
  @media only screen and (max-width: 768px) {
    margin-left: 60px;
    margin-right: 20px;
  }
`;

export default TermsOfService;
